module.exports = __webpack_public_path__ + "img/ico_chaozhilibao.392f9987.png";